module.exports = __webpack_public_path__ + "static/media/instituciones.6b168f93.png";